import { CookiesService } from './../cookies/cookies.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { publicS3Url } from './../../../../environments/environment';
import { BreakpointObserver } from '@angular/cdk/layout';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '@web/base/shared/components/base/base.component';
import { SharedService } from '@web/shared/shared.service';
import { getCookie, order } from '@web/shared/utils';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { CoreService } from '../core.service';
import { MenuService } from '../menu/menu.service';
import { Subscription } from 'rxjs';
import { IResponse } from '@web/base/shared/models/response.model';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { PopupDialogComponent } from '../popup-dialog/popup-dialog.component';
import { ConstantsProject } from '@web/project/shared/constants.class';
import { TemplateDialogService } from './dialogs/template-dialog.service';

@Component({
  selector: 'web-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss'],
  providers: [TemplateDialogService]
})
export class TemplateComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild('addThisScriptContainer') addThisScriptContainer: ElementRef

  public showCookiesInfo = false;
  public showSidenav = true;
  public showContent = false;

  public sidenavStatusSubscription: Subscription;

  public publicS3Url = publicS3Url;

  public showTemplate = false;
  public showBreadcrumb = true;

  constructor(
    translate: TranslateService,
    dialog: MatDialog,
    public sharedService: SharedService,
    private coreService: CoreService,
    private menuService: MenuService,
    public route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    public router: Router,
    public cookiesService: CookiesService,
    public templateDialogService: TemplateDialogService,
    private renderer2: Renderer2
  ) {
    super(translate, null, dialog);

    breakpointObserver.observe(['(max-width: 959px)']).subscribe(res => {
      this.coreService.setIsMobile(res.matches);
      this.coreService.setSidenavStatus(false);
    });

    // Registros de iconos para usar
    iconRegistry.addSvgIcon('ico-linked-in', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/ico-linked-in.svg'));
    iconRegistry.addSvgIcon('ico-whatsapp', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/ico-whatsapp.svg'));
    iconRegistry.addSvgIcon('ico-pinterest', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/ico-pinterest.svg'));
    iconRegistry.addSvgIcon('ico-reddit', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/ico-reddit.svg'));
    iconRegistry.addSvgIcon('ico-twitter', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/ico-twitter.svg'));
    iconRegistry.addSvgIcon('ico-email', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/ico-email.svg'));
    iconRegistry.addSvgIcon('ico-facebook', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/ico-facebook.svg'));
    iconRegistry.addSvgIcon('ico-google-plus', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/ico-google-plus.svg'));
    iconRegistry.addSvgIcon('user', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/user.svg'));
    iconRegistry.addSvgIcon('home', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/home.svg'));
    iconRegistry.addSvgIcon('chevron-right', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/chevron-right.svg'));
    iconRegistry.addSvgIcon('chevron-down', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/chevron-down.svg'));
    iconRegistry.addSvgIcon('search', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/search.svg'));
    iconRegistry.addSvgIcon('ico-logo', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/ico-logo.svg'));
    iconRegistry.addSvgIcon('see-more', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/see-more.svg'));
    iconRegistry.addSvgIcon('lock', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/lock.svg'));
    iconRegistry.addSvgIcon('attachment', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/attachment.svg'));
    iconRegistry.addSvgIcon('mail', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/mail.svg'));
    iconRegistry.addSvgIcon('group', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/group.svg'));
    iconRegistry.addSvgIcon('calendar', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/calendar.svg'));
    iconRegistry.addSvgIcon('question', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/question.svg'));
    iconRegistry.addSvgIcon('esperanto-ia', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/esperanto-ia.svg'));
    iconRegistry.addSvgIcon('file-description', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/file-description.svg'));
    iconRegistry.addSvgIcon('download', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/shared-icons/download.svg'));

    // Registros de iconos del menu para usar
    iconRegistry.addSvgIcon('ico-project', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-project.svg'));
    iconRegistry.addSvgIcon('ico-formation', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-formation.svg'));
    iconRegistry.addSvgIcon('ico-models', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-models.svg'));
    iconRegistry.addSvgIcon('ico-observatories', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-observatories.svg'));
    iconRegistry.addSvgIcon('ico-portals', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-portals.svg'));
    iconRegistry.addSvgIcon('ico-queries', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-queries.svg'));
    iconRegistry.addSvgIcon('ico-products', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-products.svg'));
    iconRegistry.addSvgIcon('ico-portal-secretaria', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-portal-secretaria.svg'));
    iconRegistry.addSvgIcon('ico-catastrofes', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-catastrofes.svg'));
    iconRegistry.addSvgIcon('ico-biblioteca', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-biblioteca.svg'));
    iconRegistry.addSvgIcon('ico-cursos', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-cursos.svg'));
    iconRegistry.addSvgIcon('ico-fondos-comunitarios', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-fondos-comunitarios.svg'));
    iconRegistry.addSvgIcon('ico-jornadas', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-jornadas.svg'));
    iconRegistry.addSvgIcon('ico-documentacion', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-documentacion.svg'));
    iconRegistry.addSvgIcon('ico-master', sanitizer.bypassSecurityTrustResourceUrl('./../../../assets/img/menu-icons/ico-master.svg'));
  }

  ngOnInit() {

    // Cookies ------------------------------
    this.cookiesService.showCookiesConsent.subscribe(v => {
      this.showCookiesInfo = v;
    });
    if (getCookie(ConstantsProject.COOKIES_CONSENT) !== null) {
      this.cookiesService.showCookiesConsent.next(false);
      this.showCookiesInfo = false;
    } else {
      this.showCookiesInfo = true;
    }
    // --------------------------------------

    this.subscriptions.push(
      this.sharedService.showSidenav$.subscribe(v => {
        setTimeout(() => (this.showSidenav = v));
      })
    );

    this.subscriptions.push(
      this.sharedService.showBreadcrumb$.subscribe(v => {
        setTimeout(() => (this.showBreadcrumb = v));
      })
    );

    this.subscriptions.push(this.sharedService.showTemplate$.subscribe(v => {
      if (this.showTemplate !== v) {
        setTimeout(() => {
          this.showTemplate = v;
        }, 100);
      }
    }));

    this.getTranslations(['core']);

    this.menuService.createMenu();

    this.subscriptions.push(
      this.coreService.templateLoaded$.subscribe((v: IResponse) => {

        if (v) {
          // Banners
          // this.bannersSidenav = v.result.banners
          //   .filter(b => b.bannerPositionID === this.BANNER_SIDE)
          //   .sort((a, b) => order(a, b));
          // this.coreService.setBannersSidenav(this.bannersSidenav);

          // Ventanas emergentes
          this.route.queryParams.subscribe((params: Params) => {
            const popupId = params['showPopupId'];
            if (popupId) {
              this.sharedService
                .loadPopup(popupId)
                .subscribe((res: IResponse) => {
                  this.dialog.open(PopupDialogComponent, {
                    panelClass: ['dialog', 'popup-dialog'],
                    width: '95%',
                    maxWidth: '750px',
                    data: { popup: res.result }
                  });
                });
            } else {
              v.result.popups.map(p => {
                if (p && !getCookie(ConstantsProject.COOKIES_PREFIX + 'popup_' + p.popupID)) {
                  this.dialog.open(PopupDialogComponent, {
                    panelClass: ['dialog', 'popup-dialog'],
                    width: '95%',
                    maxWidth: '750px',
                    data: { popup: p }
                  });
                }
              });
            }
          });

          // Usuario
          if (v.result.user) {
            if (v.result.user.token) {
              // Actualizamos el token de autenticación con el que nos llega desde el template, que contiene el vectorStore actual del usuario.
              localStorage.setItem(ConstantsProject.TOKEN_KEY, v.result.user.token);
            }

            // Quieren que los colegiados actualicen cada año si son colegiados o no, pongo esto aquí porque en las jornadas es donde más entran.
            if (v.result.user.askIsCollegiate) {
              this.templateDialogService.openDialogCollegiateUpdate().subscribe(result => {
                if (result) {
                  const value: any = result;
                  value.emailUser = v.result.user.email;
                  this.sharedService.updateCollegiate(v.result.user.userWebID, value).subscribe();
                }
              });
            }
          }

        }
      })
    );

    this.coreService.loadTemplate();

    // Cerrar el sidenav si pasamos de 'resolución movil' a PC
    this.sidenavStatusSubscription = this.coreService
      .getSidenavStatus()
      .subscribe(status => {
        if (status === false) {
          this.sidenav.close();
        } else {
          this.sidenav.open();
        }
      });

    this.showContent = true;
  }

  ngAfterViewInit() {
    // Cargar el script de AddThis (addToaAny)
    // Lo cargamos una sola vez, en la carga del template y luego ya lo reseteamos/inicializamos en el componente AddThis
    // De esta forma evitamos cargar continuamente el script en cada componente que use AddThis, lo que daba inestabilidad y provicaba que a veces no saliese.

    const cookiesConsent = JSON.parse(getCookie(ConstantsProject.COOKIES_CONSENT));
    const addThisScriptContainer = this.addThisScriptContainer.nativeElement;

    if (cookiesConsent?.functionals) {
      const s = this.renderer2.createElement('script');
      s.type = 'text/javascript';
      s.src = 'https://static.addtoany.com/menu/page.js';
      this.renderer2.appendChild(addThisScriptContainer, s);
    }
  }

  openCookiesPolicy() {
    this.router.navigateByUrl("cookies");
  }

  onSidenavClosedStart() {
    this.coreService.setSidenavStatus(false);
  }

  onSidenavOpenedStart() {
    this.coreService.setSidenavStatus(true);
  }

  onActivate(event) {
    // window.scroll(0, 0);
  }
}
